import './theme/variables/LoadCssVariables.js';
import React__default, { createContext } from 'react';
import { GlobalTokens, ComponentTokens } from './theme/variables/AntdToken.js';
import ConfigProvider from './external_lib/antd/es/config-provider/index.js';
var ThemeContext = createContext({});
var ThemeProvider = function (_a) {
  var children = _a.children;
  return React__default.createElement(ConfigProvider, {
    prefixCls: "hrn",
    theme: {
      hashed: false,
      token: GlobalTokens,
      components: ComponentTokens
    }
  }, React__default.createElement(ThemeContext.Provider, {
    value: {}
  }, children));
};
export { ThemeContext, ThemeProvider as default };
//# sourceMappingURL=provider.js.map
